<template>
  <div class="content">
    <!-- 新增按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-button type="primary" @click="kaihuBtn">新增</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <el-table
      :data="beforArr"
      style="width: 100%;overflow-y: scroll;"
      height="calc(100vh - 220px)"
      v-loading="loading"
 
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column label="图片" width="100" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.url" alt style="width:100%" />
        </template>
      </el-table-column>
      <el-table-column label="链接" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.link ? scope.row.link : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="排序(从小到大排序)" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="ejectupdateGoods(scope.row)"
            >修改</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="deleteAdmin(scope.row)"
            :disabled="$store.state.supUser.roleId == 1"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增表单 -->
    <el-dialog
      :title="inputTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item
          label="链接(商品页路径: /pages/productList/productList 详情页路径:/pages/details/details?productId=1025)"
        >
          <el-input
            v-model="form.link"
            auto-complete="off"
            clearable
            placeholder="请输入小程序路径,可联系技术人员复制"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort" auto-complete="off"></el-input>
        </el-form-item>
        <!-- 图片预览 -->
        <el-form-item label="图片预览">
          <!-- <div>已上传图片列表</div> -->
          <div class="demo-image__preview">
            <el-image
              style="width: 100px; height: 100px"
              :src="this.form.url"
              :preview-src-list="[this.form.url]"
            >
            </el-image>
          </div>
        </el-form-item>
      </el-form>
      
      <el-upload
        class="upload-demo"
        :action="action"
        :multiple="false"
        :on-success="handleSuccess_cover"
        :file-list="fileList"
        list-type="picture"
        name="formData"
        :limit="1"
      >
        <el-button size="small" type="primary"
          >点击上传图片(1张),会覆盖之前的</el-button
        >
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，750px X 300px
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectBanner,
  addBanner,
  updateBanner,
  deleteBanner,
} from "@/services/mall/banner.js";
import { IP } from "@/services/index.js";
export default {
  data() {
    return {
      beforArr: [],
      inputTitle: "新增",
      cover: "",
      fileList: [], //上传列表
      action: IP + "/uploadFile/add",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" },
      ],
      form: {},
      dialogFormVisible: false,
    };
  },
  created() {

    this.selectData();
  },
  methods: {
    // 查询
    selectData() {
      selectBanner().then((resp) => {

        this.loading = false;
        this.beforArr = resp.data;
      });
    },
    // 新增按钮
    kaihuBtn() {
      this.inputTitle = "新增";
      this.dialogFormVisible = true;
      this.form = {};
      this.fileList = [];
    },
    ejectupdateGoods(row) {
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
    },
    /* 上传图片 */
    handleSuccess_cover(e) {
      console.log(e.data);
      this.form.url = e.data;
      // console.log(this.form);
    },
    // 表单提交按钮
    sumbmitBtn() {
      console.log(this.form);
      if (this.form.url == "" || this.form.url == null) {
        this.$message.error("请上传图片");
        return;
      }
      if (this.form.sort == "" || this.form.sort == null) {
        this.form.sort = 0;
      }
      if (this.form.link == "" || this.form.link == null) {
        this.form.link = "";
      }
      if (this.inputTitle == "新增") {
        addBanner(this.form.url, this.form.link, this.form.sort).then((res) => {
   
          if (res.code == 200) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: "新增轮播图成功!",
            });
            this.selectData();
          } else {
            this.$message({
              type: "info",
              message: "网络错误",
            });
          }
        });
        return;
      }

      updateBanner(
        this.form.id,
        this.form.url,
        this.form.link,
        this.form.sort
      ).then((res) => {
 
        if (res.code == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.selectData();
        } else {
          this.$message({
            type: "info",
            message: "网络错误",
          });
        }
      });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteBanner(row.id).then((resp) => {
    
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selectData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
.content {
  margin: 10px auto;
  width: 98%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>
